<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>
      <div style="font-size: 20px;">{{ selectedStore.storeName }}</div>
      <div style="height: 30px;"></div>

      <!-- 날짜 -->
      <v-text-field v-model="salesReportDate" label="売上日" prepend-icon="event" disabled></v-text-field>

      <!-- 판매원 검색 -->
      <v-select
        v-model="reportedUsers"
        :items="reportedUsers"
        :label="$t('sales.salesperson')"
        persistent-hint
        prepend-icon="group"
        multiple
        chips
        disabled
        return-object
        v-if="isReported"
      ></v-select>
      
      <v-autocomplete
        v-model="selectedUsers"
        :items="salesUsers"
        item-text="userName"
        :label="$t('sales.salesperson')"
        persistent-hint
        prepend-icon="group"
        multiple
        chips
        deletable-chips
        return-object
        v-else
      ></v-autocomplete>

      <v-card>
        <v-card-text>
          <v-card-title class="title-highlight">
            {{ $t('title.sales-report') }}
          </v-card-title>

          <v-flex xs12 sm12 v-if="isReported">
            <v-alert
              :value="true"
              color="warning"
              icon="info"
              outline
              class="font-weight-bold"
              style="text-align: left;"
            >報告済</v-alert>
          </v-flex>

          <div style="height: 20px;"></div>
          
          <v-layout row wrap align-center>
            <v-flex xs6 sm4  class="mr-4">  <!-- 오른쪽에 여백 -->
              <v-select
                class="field--h40"
                v-model="selectedItemCategory"
                :items="itemCategories"
                label="商品カテゴリ"
                item-text="itemCategoryName"
                item-value="itemCategoryId"
                prepend-icon="category"
                dense
                outlined
                hide-details
              />
            </v-flex>

            <v-flex xs6 sm4>
              <v-text-field
                class="field--h40"
                type="number"
                min="0"
                v-model="search"
                append-icon="search"
                :label="$t('sales.stocktaking-search')"
                dense
                outlined
                hide-details
                clearable
              />
            </v-flex>
          </v-layout>
          
          <!-- 여백 -->
          <div style="height: 20px;"></div>

          <v-data-table
            id="dt"
            :headers="headers"
            :items="filteredItems"
            hide-actions
            class="elevation-1"
            style="width: 100%; margin: 15px 0 0;"
            :no-data-text="$t('noTableDataAvailable')"
          >
            <template v-slot:items="props">
              <tr v-bind:class="{'confirmed-items': isReported }" >
                <td class="text-xs-center px-2">{{ props.item.janCode }}</td>
                <td class="text-xs-left px-2">{{ props.item.itemName }}</td>
                <td class="text-xs-right">{{ Number(props.item.unitPrice || 0).toLocaleString() }}</td>
                <td class="text-xs-right">
                  <input 
                    type="number"
                    v-model.number="props.item.quantity"
                    class="column-input-for-order"
                    @change="editItem(props.item)"
                    min="0"
                  />
                </td>
                <td class="text-xs-right">{{ props.item.presentQuantity }}</td>
                <td class="text-xs-right">
                  {{ (Number(props.item.unitPrice || 0) * Number(props.item.quantity || 0)).toLocaleString() }}
                  <!-- {{ Number(props.item.unitPrice) * Number(props.item.quantity) }} -->
                </td>
                
              </tr>
            </template>

            <template v-slot:footer>
              <tr class="grand-total-row">
                <td colspan="5" class="text-xs-right font-weight-bold px-3">
                  合計金額
                </td>
                <td class="text-xs-right font-weight-bold px-3">
                  {{ grandTotal.toLocaleString() }}
                </td>
              </tr>
            </template>
          </v-data-table>
            
          <v-flex xs12 sm12>
            <div style="height: 30px;"></div>
          </v-flex>

          <v-flex xs12 sm12>
            <v-textarea
              outline
              v-model="comments"
              counter="1000"
              :label="$t('attributes.comments')"
              clearable
              v-bind:readonly="isReported"
            ></v-textarea>
          </v-flex>
          
        </v-card-text>
      </v-card>

      <!-- 버튼 영역 -->
      <div class="footer-btns">
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/report-confirm' }">
          <v-icon dark left>arrow_back</v-icon>{{ $t('back-btn') }}
        </v-btn>
        <v-btn block color="primary" dark @click="registSalesReport()"
            :disabled="isReported"
            :loading="loading"
          >取扱商品を登録する</v-btn>
      </div>
    </v-container> 
  </v-form>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'

export default {
  created() {
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    this.selectedStore = JSON.parse(sessionStorage.getItem("selectedStore"))
    this.getSalesReportItemsReg()
  },
  computed: {
    salesReportDate: {
      get() {
        return this.$store.state.salesSession.salesReportDate
      },
      set(value) {
        this.$store.commit('SET_SALES_REPORT_DATE', value)
      }
    },
    filteredItems() {
      let items = this.reportItems;

      // '全て'는 전체 표시
      if (this.selectedItemCategory && this.selectedItemCategory !== '#') {
        items = items.filter(
          item => item.itemCategoryId === this.selectedItemCategory
        );
      }

      // JAN 검색 (별개로 작동)
      if (this.search) {
        const keyword = this.search.toString().trim();
        items = items.filter(item =>
          item.janCode && item.janCode.toString().includes(keyword)
        );
      }

      return items;
    },
    grandTotal() {
      return this.filteredItems.reduce((sum, item) => {
        return sum + (Number(item.unitPrice || 0) * Number(item.quantity || 0))
      }, 0)
    }
  },
  methods: {
    getSalesReportItemsReg() {
      let thisObj = this

      ServerApiCallService.itemCategoriesByStatus()
      .then(response => {        
        
        thisObj.itemCategories = response.data.itemCategories
        thisObj.itemCategories.unshift({
          itemCategoryId: '#',
          itemCategoryName: '全て'
        })

        // 初期表示時の
        thisObj.loading = false // 初期表示時の TODO
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })

      let request = {
        storeCode: this.selectedStore.storeCode,
        salesReportDate: this.salesReportDate.replace(/\//g, '')
        
      }

      ServerApiCallService.salesReportItemsReg(request)
        .then(response => {

          thisObj.isReported = response.data.isReported

          if (thisObj.isReported) {
            thisObj.reportItems = response.data.reportedItems

            if (response.data.workedUsers) {
              thisObj.reportedUsers = []
              response.data.workedUsers.forEach(function(row) {
                var reportedUser = row.userId + ' ' + row.createdUser
                thisObj.reportedUsers.push(reportedUser)
              })
            }

            thisObj.comments = response.data.reportedItems[0].comments
          } else {
            thisObj.reportItems = response.data.items

            response.data.users.forEach(function(row) {
              var userList = {}
              if (!row.firstName) {
                userList = {
                  userId: row.userId,
                  userName: row.userId + ' ' + row.lastName
                }
              } else {
                userList = {
                  userId: row.userId,
                  userName:
                    row.userId + ' ' + row.lastName + ' ' + row.firstName
                }
              }
              thisObj.salesUsers.push(userList)
            })
          }

          // 商品の表示順 商品カテゴリ、商品名
          // thisObj.reportItems.sort(function(a, b) {
          //   if (a.itemName > b.itemName) return 1
          //   if (a.itemName < b.itemName) return -1
            
          //   return 0
          // })
          // thisObj.reportItems.sort(function(a, b) {
          //   if (a.itemCategoryId > b.itemCategoryId) return 1
          //   if (a.itemCategoryId < b.itemCategoryId) return -1
            
          //   return 0
          // })

          thisObj.reportItems.sort((a, b) => {
            if (a.itemCategoryId !== b.itemCategoryId) {
              return a.itemCategoryId > b.itemCategoryId ? 1 : -1
            }
            return a.itemName.localeCompare(b.itemName)
          })
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    },
    editItem(item) {
      if (this.isReported) {
        return
      }

      this.editedItem = Object.assign({}, item)
      this.updateQuantity();
    },
    updateQuantity() {
      let thisObj = this

      this.reportItems.forEach(function(row) {
        if (row.itemCode == thisObj.editedItem.itemCode) {
          row.quantity = Number(thisObj.editedItem.quantity)
          row.presentQuantity = Number(thisObj.editedItem.presentQuantity)
          row.referenceStock = Number(thisObj.editedItem.referenceStock)
        }
      })
    },
    registSalesReport() {
      this.workedUsers = []
      for (let i = 0; i < this.selectedUsers.length; i++) {
        this.workedUsers.push(this.selectedUsers[i].userId)
      }

      var registReportItems = this.reportItems.filter(
        item => item.quantity > 0 || item.presentQuantity > 0
      )

      var sumPrice = 0
      registReportItems.forEach(function(row) {
        sumPrice += row.unitPrice * row.quantity
      })

      if (registReportItems.length === 0) {
        this.$parent.$parent.$parent.showErrorDialog(
          '最低１つの商品に個数を入力してください'
        )
        return
      }

      this.loading = true

      let request = {
        storeCode: this.selectedStore.storeCode,
        salesReportDate: this.salesReportDate.replace(/\//g, ''),
        workedUsers: this.workedUsers,
        comments: this.comments,
        sumTotal: sumPrice,
        salesReportDetail: registReportItems
      }

      ServerApiCallService.registSalesReportByUser(request)
        .then(response => {
          this.loading = false
          this.$router.push({
            name: 'admin/report-confirm',
          })
        })
        .catch(error => {
          console.log("registSalesReportByUser err");
          this.loading = false
        })
    },
  },
  data() {
    return {
      loading: false,
      selectedUsers: [],
      selectedStore: [],
      comments: '',
      reportedUsers: [],
      isReported: false,
      updateDialog: false,
      editedItem: [],
      reportItems: [],  // 전체 상품 목록
      search: '',  // JAN 검색어
      selectedItemCategory: '#',  // 단순 값으로 변경 ('#' = 全て)
      itemCategories: [],
      headers: [
        {
          text: 'JANコード',
          align: 'center',
          value: 'janCode',
          width: '15%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          width: '25%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('attributes.unitPrice'),
          align: 'right',
          sortable: false,
          value: 'unitPrice',
          width: '15%',
          fixed: true,
          class: 'px-2'
        },
        {
          text: 'Sales quantity',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          width: '15%',
          fixed: true,
          class: 'px-2'
        },        
        {
          text: this.$t('attributes.present'),
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          width: '15%',
          fixed: true,
          class: 'px-2'
        },
        {
          text: 'Total amount',
          align: 'right',
          sortable: false,
          value: 'subTotal',
          width: '15%',
          fixed: true,
          class: 'px-2'
        }
      ],

      workedUsers: [],
      salesUsers: []
    }
  }
}
</script>

<style>
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
#dt tr:nth-child(even) {
  background-color: #f2f2f2;
}
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
.confirmed-items {
  background-color: #adadad;
}

/* 공통 높이: 40px */
.field--h40 {
  margin-right: 12px; /* 카테고리와 JAN 사이 간격 */
}
.field--h40 .v-input__control {
  min-height: 40px !important;
}
.field--h40 .v-input__slot {
  height: 40px !important;
  min-height: 40px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* 텍스트 필드 내부 인풋 라인 높이 */
.field--h40 input {
  height: 40px !important;
  line-height: 40px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* v-select 선택 영역 높이 */
.field--h40 .v-select__selections {
  min-height: 40px !important;
}

/* outlined + dense 라벨 정렬 보정 */
.field--h40.v-text-field--outlined .v-label,
.field--h40.v-select.v-text-field--outlined .v-label {
  top: 10px !important; /* 필요 시 8~12px 사이로 미세조정 */
}

/* 숫자 인풋 스피너 제거(브라우저별) */
.field--h40 input[type=number]::-webkit-outer-spin-button,
.field--h40 input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.field--h40 input[type=number] {
  -moz-appearance: textfield;
}
.grand-total-row {
  background-color: #e8f0f7;
}
.grand-total-row td {
  border-top: 2px solid #4C728A;
  font-size: 15px;
}
.column-input-for-order {
  width: 80px;
  height: 30px;
  border: 1px solid #999;
  border-radius: 4px;
  font-size: 14px;
  text-align: right;
  padding: 0 6px;
  background-color: #fff;
}
</style>
